<template>
<v-app>
    <v-container fill-height>
        <v-row justify='center'>
            <v-col cols="6">
                <v-sheet>
                    <v-card id="rounded-card" height="100%" :elevation="elevation">
                        <v-row justify="center">
                            <v-img contain style="padding-top:40px" height="200px" width="100%" :src="require('../assets/12.png')" /><br />
                        </v-row>
                        <v-layout justify="center">
                            <v-flex xs10 md10 offset-xs1 style="padding-top:2%">

                                <h2 style="text-align:center">{{data.menu[data.language]['login']}}</h2>
                                <v-text-field style="padding-top:3% ; border-radius:10px" v-model="username" :label="data.menu[data.language]['username']" required outlined dense></v-text-field>
                                <v-text-field v-model="password" style="border-radius:10px" hide-details :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showpassword ? 'text' : 'password'" :label="data.menu[data.language]['password']" required @click:append="showpassword = !showpassword" outlined dense></v-text-field>
                                <v-col cols="12" style="padding-top:1vh">
                                    <v-row justify="center">
                                        <v-col class="text-start">
                                            <!-- <v-checkbox label="จดจำรหัส" color="primary2" value="remember" hide-details></v-checkbox> -->
                                        </v-col>
                                        <v-col class="text-end" style="padding-top:2vh">
                                            <!-- <v-flex style="font-size:18px; padding-top:8px;" @click="$router.push('/Forgetpassword')">Forget Password?</v-flex> -->
                                            <!-- <a @click="$router.push('/Forgetpassword')" style="font-size:18px;  ">{{data.menu[data.language]['forgot_password']}}?</a> -->
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- <div class="text-center" style="padding-bottom:2%"> -->
                                <!-- <v-btn class="box" width="50%" rounded dark dense style="height:45px; font-size:20px" @click="$router.push('/Home')">
                                        เข้าสู่ระบบ
                                    </v-btn> -->
                                <p class="text-center">
                                    <v-btn width="50%" outlined rounded dense style="height:45px; font-size:20px" @click="login">
                                        {{data.menu[data.language]['login']}}
                                    </v-btn>
                                </p>
                                <!-- </div -->

                            </v-flex>
                        </v-layout>

                    </v-card>
                </v-sheet>
            </v-col>
        </v-row>
    <v-snackbar v-model="data.alart" :timeout="timeout">
            {{ data.alaert_text }}
        </v-snackbar>

    </v-container>
</v-app>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data: () => ({
        alart : true,
        username: null,
        password: null,
        elevation: 2,
        showpassword: false,
        checkbox: false,
        zIndex: 0,
        opacity: 0.9,
        timeout: 10000,
    }),
    methods: {

        login() {
            let payload = new FormData()
            payload.append('email', this.username)
            payload.append('password', this.password)
            this.$store.dispatch("datas/login", payload)

            // this.$store.dispatch("datas/login", payload)
            this.username = null
            this.password = null

        },
    },

    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
        formlogin() {
            return (
                this.username &&
                this.password
            )
        },
        token() {
            return this.$store.state.datas.data.token
        }
    },

    watch: {
        token() {
            // console.log("namamma")
            this.$router.push({
                name: 'Home'
            });

        }
    },
    created() {
        if (this.$store.state.datas.data.token != null) {
            this.$router.push({
                name: 'Home'
            });
        }
    }

}
</script>

<style>
.v-card--reveal {
    bottom: 0;
    opacity: 1 !important;
    position: absolute;
    width: 100%;

}

#rounded-card {
    border-radius: 20px;
    -webkit-box-shadow: 0 20px 50px rgba(0, 0, 0, .2);
    box-shadow: 0 -1px 10px rgba(0, 0, 0, .2) !important;
    padding-left: 3%;
    padding-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
}
</style>
